import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { translate } from 'react-polyglot'

import { Button } from 'components'
import Toolbar from 'components/Editor/Components/Toolbars/Toolbar'

import './embedInput.scss'

class EmbedInput extends Component {
	state = {
		embedInputUrl: '',
	}

	constructor() {
		super()

		this.embedInputContainer = React.createRef()
	}

	componentDidMount() {
		this.updatePosition()
		window.addEventListener('keydown', this.onKeyDown, true)
		window.addEventListener('resize', this.updatePosition)
		document
			.querySelector('.o-page__content')
			.addEventListener('scroll', this.updatePosition)
		document.addEventListener('mousedown', this.handleClickOutside)
	}

	componentDidUpdate = () => {
		this.updatePosition()
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.onKeyDown, true)
		window.removeEventListener('resize', this.updatePosition)
		document
			.querySelector('.o-page__content')
			.removeEventListener('scroll', this.updatePosition)
		document.removeEventListener('mousedown', this.handleClickOutside)
	}

	onKeyDown = e => {
		if (e.keyCode === 27) {
			this.props.onClose()
		}
	}

	handleKeyDown = event => {
		const { embedInputUrl } = this.state

		const { onSubmit, onClose } = this.props

		if (event.keyCode === 13 && embedInputUrl.length > 0) {
			onSubmit(embedInputUrl)
			this.setState({ embedInputUrl: '' })
		}

		if (event.keyCode === 27) {
			onClose()
			this.setState({ embedInputUrl: '' })
		}
	}

	handleChange = event => {
		this.setState({ embedInputUrl: event.target.value })
	}

	handleClickOutside = event => {
		const { onClose } = this.props

		const container = this.embedInputContainer.current

		if (container && !container.contains(event.target)) {
			onClose()
		}
	}

	updatePosition = () => {
		const { editor } = this.props

		if (editor.value.focusBlock) {
			const block = editor.findDOMNode(
				editor.value.document.getPath(editor.value.focusBlock.key)
			)
			const blockRect = block.getBoundingClientRect()

			let leftPosition = blockRect.left

			if (!block.classList.contains('o-editor__section')) {
				const parentRect = block.offsetParent.getBoundingClientRect()

				leftPosition = parentRect.left
			}

			this.embedInputContainer.current.style.top = `${blockRect.top}px`
			this.embedInputContainer.current.style.left = `${leftPosition}px`
		}
	}

	render() {
		const { suggestionType, onSubmit, t } = this.props

		const { embedInputUrl } = this.state

		return ReactDOM.createPortal(
			<Toolbar
				toolbarRef={this.embedInputContainer}
				className="c-embed-input is-visible"
			>
				<img src={`/assets/img/${suggestionType}.svg`} alt="" />
				<input
					type="text"
					placeholder={t('editor.enter_link_url')}
					value={embedInputUrl}
					autoFocus
					onChange={this.handleChange}
					onKeyDown={this.handleKeyDown}
					className="c-form__input c-form__input--ghosted c-form__input--wide"
				/>
				<Button
					layout="ghosted"
					size="small"
					text={t('editor.embed')}
					onClick={() => {
						if (embedInputUrl.length > 0) {
							onSubmit(embedInputUrl)
							this.setState({ embedInputUrl: '' })
						}
					}}
				/>
			</Toolbar>,
			document.getElementById('root')
		)
	}
}

export default translate()(EmbedInput)
